$('.insta_slider').slick({
  infinite: true,
  dots:true,
  arrows:false,
  slidesToShow: 3,
  slidesToScroll: 1
});

jQuery(".faq_box h5").first().addClass("show");
		jQuery(".faq_box  h5").click(function(){if(jQuery(this).hasClass("show"))
		{jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
		else
		{jQuery(".faq_box h5").removeClass("show");jQuery(".faq_box h5").next().slideUp();jQuery(this).addClass("show");jQuery(this).next().slideDown();}});

jQuery(".footer-block__heading").click(function(){
  if($(window).width() <= '749'){
  if(jQuery(this).hasClass("show"))
        {
          jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
  else
        {
          jQuery(".footer-block__heading").removeClass("show");
          jQuery(".footer-block__heading").next().slideUp();
          jQuery(this).addClass("show");jQuery(this).next().slideDown();
        }
    }
});